import {
  CUSTOMER_STOCK_SOURCE_FIELDS,
  CUSTOMER_STOCK_VIN_COLUMN,
  findStockHeader,
  normalizeStockHeader,
} from './customerStockFields';
import { detectVinColumn } from './detectVinColumn';

const VIN_HEADER_ALIASES = [
  CUSTOMER_STOCK_VIN_COLUMN,
  'Full VIN',
  'VIN Code',
  'VIN',
  'Serial Number',
  'Chassis Number',
  'Chassis No',
  'Chassis',
  'Vehicle Identification Number',
];

export type StockColumnChoice = {
  vin?: string;
  location?: string;
  model?: string;
};

export const matchStockHeader = (
  headers: string[],
  aliases: readonly string[],
) => {
  const matches = new Set<string>();
  aliases.forEach((alias) => {
    const header = findStockHeader(headers, alias);
    if (header) matches.add(header);
  });
  return matches.size === 1 ? [...matches][0] : undefined;
};

export const suggestStockColumns = (
  headers: string[],
  rows: Record<string, unknown>[],
): StockColumnChoice => {
  const vin =
    matchStockHeader(headers, VIN_HEADER_ALIASES) ??
    detectVinColumn(headers, rows);
  const used = new Set(vin ? [normalizeStockHeader(vin)] : []);
  const take = (aliases: readonly string[]) => {
    const header = matchStockHeader(headers, aliases);
    if (!header || used.has(normalizeStockHeader(header))) return undefined;
    used.add(normalizeStockHeader(header));
    return header;
  };

  return {
    vin,
    location: take(CUSTOMER_STOCK_SOURCE_FIELDS[0].aliases),
    model: take(CUSTOMER_STOCK_SOURCE_FIELDS[1].aliases),
  };
};
